var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.hasDownloadLogId
    ? _c(
        "span",
        { staticClass: "download-password-button" },
        [
          _c(
            "el-button",
            {
              staticClass: "download-password-trigger",
              attrs: { type: "text", disabled: _vm.loading || _vm.disabled },
              on: { click: _vm.showPassword },
            },
            [
              _c("i", { staticClass: "el-icon-view" }),
              _vm._v(
                "\n    " +
                  _vm._s(
                    _vm.loading
                      ? _vm.$t("downloadLogUi.loading")
                      : _vm.$t("downloadLogUi.showPassword")
                  ) +
                  "\n  "
              ),
            ]
          ),
          _c(
            "vuestic-modal",
            {
              ref: "passwordModal",
              attrs: {
                alignModal: "download-password-modal",
                "no-buttons": true,
              },
            },
            [
              _c("div", { attrs: { slot: "title" }, slot: "title" }, [
                _vm._v(_vm._s(_vm.$t("downloadLogUi.zipPassword"))),
              ]),
              _c(
                "div",
                { staticClass: "download-password-content" },
                [
                  _c(
                    "el-input",
                    { attrs: { value: _vm.password, readonly: "" } },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "copy-button",
                          class: { "is-copied": _vm.copied },
                          attrs: { slot: "append" },
                          on: { click: _vm.copyPassword },
                          slot: "append",
                        },
                        [
                          _c("i", {
                            class: _vm.copied
                              ? "el-icon-check"
                              : "el-icon-document-copy",
                          }),
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.copied
                                  ? _vm.$t("downloadLogUi.copied")
                                  : _vm.$t("downloadLogUi.copy")
                              ) +
                              "\n        "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }